<template>
  <div id="pageRoot">
    <img
      id="title"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo31bg.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 55px; top: 140px">
      <p>Presta atención a las expresiones destacadas.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 55px; top: 190px">
      <p>Marca la opción correcta.</p>
    </span>

    <p class="textBase appearAnimationB" id="text01">
      LOS SAPOS SON ANIMALES QUE
    </p>

    <p class="textBase hover-animation-c appearAnimationA" id="tag01">
      CARECEN DE COLA
    </p>

    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >los sapos son animales que tienen la cola larga.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >los sapos son animales que no tienen cola.
      <input type="radio" name="sapos" />
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#title {
  position: absolute;
  left: 65px;
  top: 59px;
}
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 30px;
}
#text01 {
  position: absolute;
  width: 730px;
  height: 50px;
  left: 70px;
  top: 334px;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #000000;
}
#tag01 {
  position: absolute;
  width: 278px;
  height: 50px;
  left: 513px;
  top: 333px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
}
#text02 {
  position: absolute;
  left: 69px;
  top: 415px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}

#toggle01 {
  position: absolute;
  left: 67px;
  top: 488px;
}
#toggle02 {
  position: absolute;
  left: 67px;
  top: 563px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 141b.mp4",
        "glo/Video 142b.mp4",
      ]
    }
  }
}
</script>